/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { PostApiAuthBarberRefresh200, PostApiAuthBarberRefresh400, PostApiAuthBarberRefresh401, PostApiAuthBarberRefreshHeaderParams, PostApiAuthBarberRefreshMutationResponse } from "../entities/PostApiAuthBarberRefresh";
import { modelsAuthSessionOutputSchema } from "./models/authSessionOutputSchema";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { z } from "zod/v4";

export const postApiAuthBarberRefreshHeaderParamsSchema = z.object({
    "Cookie": z.string().describe("barber_refresh_token=<token>")
    }) as unknown as z.ZodType<PostApiAuthBarberRefreshHeaderParams>

/**
 * @description OK
 */
export const postApiAuthBarberRefresh200Schema = z.lazy(() => modelsAuthSessionOutputSchema) as unknown as z.ZodType<PostApiAuthBarberRefresh200>

/**
 * @description Bad Request
 */
export const postApiAuthBarberRefresh400Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiAuthBarberRefresh400>

/**
 * @description Unauthorized
 */
export const postApiAuthBarberRefresh401Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiAuthBarberRefresh401>

export const postApiAuthBarberRefreshMutationResponseSchema = z.lazy(() => postApiAuthBarberRefresh200Schema) as unknown as z.ZodType<PostApiAuthBarberRefreshMutationResponse>